import React from 'react'
import SubMenuWrapper from './SubMenuWrapper'
import MenuItem from '../MenuItem'

const ProductsItems = ({isSidebarOpen}) => (
  <SubMenuWrapper
    label='محصولات'
    iconClass='fa fa-book'
    isSideBarOpen={isSidebarOpen}
    className="vertical-menu"
  >

    <MenuItem
      label='همه محصولات'
      iconClass='fa fa-list'
      url='/v/list/?type=course'
      isExternal={true}
    />

    <MenuItem
      label='محصولات من'
      iconClass='fa fa-bookmark-o'
      url='/dashboard/products'
    />

  </SubMenuWrapper>
)

export default ProductsItems


// WEBPACK FOOTER //
// ./src/components/common/SidebarMenu/ProductsItems.js